import { Button, Group, Stack, Text } from "@mantine/core"
import { AppModal } from "../AppModal/AppModal"

interface ErrorModalProps {
	opened: boolean
	onClose: () => void
	header: string
	text: string
	closeLabel?: string
}

export function ErrorModal({
	opened,
	onClose,
	header,
	text,
	closeLabel = "Close"
}: ErrorModalProps) {
	return (
		<AppModal title={header} opened={opened} onClose={onClose} size="md">
			<Stack gap="lg">
				<Text ta="center">{text}</Text>
				<Group justify="center">
					<Button onClick={onClose}>{closeLabel}</Button>
				</Group>
			</Stack>
		</AppModal>
	)
}
